export const IS_TESTING = process.env.NEXT_PUBLIC_PLAYWRIGHT_ENABLED === 'true'
